import React from 'react';
import { Link } from 'react-router-dom';
import PageHeader from '../common/PageHeader';
import Reveal from '../common/Reveal';
import SectionHead from '../common/SectionHead';
import { CLIENT_SITES } from '../../config/site';
import { useLang, usePageTitle } from '../../i18n/LanguageContext';

import john from '../../assets/portfolio/john-kids.jpg';
import clinic from '../../assets/portfolio/clinic.jpg';
import lamera from '../../assets/portfolio/lamera.jpg';
import sedy from '../../assets/portfolio/sedy-abdelrahman.jpg';
import aqar from '../../assets/portfolio/aqar-elminya.jpg';
import mark from '../../assets/safehand-mark.png';

const IMAGES = { john, clinic, lamera, sedy, aqar };

// "Our Work" page (route: /portfolio, old /products still works)
export default function Products() {
  const { t, isAr } = useLang();
  const w = t.work;
  usePageTitle(w.pageTitle);

  return (
    <>
      <PageHeader crumb={w.pageTitle} eyebrow={w.eyebrow} title={w.title} lead={w.lead} />

      <section className="section">
        <div className="container">
          <Reveal className="flagship">
            <div className="flagship__logo">
              <img src={mark} alt="SafeHand" width="96" height="96" />
            </div>
            <div className="flagship__copy">
              <span className="tag tag--brand">{w.flagshipTag}</span>
              <h2>SafeHand</h2>
              <p>{w.flagshipText}</p>
            </div>
            <Link to="/safehand" className="btn btn--primary">
              {t.common.learnMore} <i className="fa-solid fa-arrow-right flip-rtl" aria-hidden="true" />
            </Link>
          </Reveal>

          <div className="grid grid--3 mt-5">
            {w.featured.map((p, i) => (
              <Reveal key={p.key} delay={(i % 3) * 80} className="work-card">
                <div className="work-card__img">
                  <img src={IMAGES[p.key]} alt={p.title} loading="lazy" />
                </div>
                <div className="work-card__body">
                  <span className="tag">{p.tag}</span>
                  <h3 className="card__title">{p.title}</h3>
                  <p className="card__text">{p.text}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <section className="section section--tint">
        <div className="container">
          <SectionHead title={w.sitesTitle} lead={w.sitesLead} />
          <div className="grid grid--3 sites">
            {CLIENT_SITES.map((site, i) => (
              <Reveal key={site.url} delay={(i % 3) * 60}>
                <a className="site-link" href={site.url} target="_blank" rel="noopener noreferrer">
                  <span className="site-link__icon">
                    <i className={`fa-solid ${site.type === 'realEstate' ? 'fa-building' : 'fa-user-doctor'}`} aria-hidden="true" />
                  </span>
                  <span className="site-link__text">
                    <strong>{isAr ? site.nameAr : site.name}</strong>
                    <small>{site.type === 'realEstate' ? w.siteDescRealEstate : w.siteDesc}</small>
                  </span>
                  <i className="fa-solid fa-arrow-up-right-from-square site-link__go" aria-hidden="true" />
                </a>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
